import React from "react";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export const ListRole = createSlice({
  name: "ListRole",
  initialState: {
    isLoading: false,
    isSuccess: false,
    isFirst: true,
    data: [],
  },
  reducers: {
    list_role: (state, action?) => {
      state.isLoading = true;
    },
    success_api_call_role: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
      state.isSuccess = true;
      state.isFirst = true;
    },
    failure_api_call_role: (state, action) => {
      state.isLoading = false;
      state.isSuccess = false;
    },
    role_is_first: (state, action) => {
      state.isFirst = false;
    },
  },
});
export default ListRole.reducer;
export const {
  list_role,
  success_api_call_role,
  failure_api_call_role,
  role_is_first,
} = ListRole.actions;
